export function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

export const navBaseClasses =
  'ring-brand w-full rounded-md px-3 py-1 text-sm font-medium focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-[3px] focus-visible:outline-light-focus dark:focus-visible:outline-dark-focus';

export const navBaseClassesResponsive =
  'block rounded-md px-3 py-2 text-base font-medium';
